import { uuidv4 } from "common";
import { JSX, ParentProps, Show, createMemo, on, onMount } from "solid-js";
import { useTabGroup } from "../st-tab-group/st-tab-group";
import style from './st-tab.module.css'

export class TabProps {
    id?: string
    label: string | JSX.Element
    readOnly?: boolean = false
    hidden?: boolean = false
    dataInvalidOnTabChange?: boolean = false
    helpId?: string
    licenseKey?: string
    lmsPage?: string
    localization?: string
    system?: boolean = false
    useInAddWizard?: boolean = false
}

export default function STTab(props: ParentProps<TabProps>) {
    const id = props.id ?? uuidv4()
    const tabGroup = useTabGroup()

    onMount(() => {
        tabGroup.addTab(id, props.label)
    })

    return (
        <Show when={tabGroup.selectedTabId() === id}>
            <div class={style['st-tab']} id={`panel-${id}`} role='tabpanel' tabindex='0' aria-labelledby={`tab-${id}`}>
                {props.children}
            </div>
        </Show>
    )
}

STTab.defaultProps = new TabProps()